import { Component } from "@angular/core";
import { ChangePassword } from "@interfaces/changePassword.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { UpdateProfile } from "@interfaces/updateProfile.interface";
import { AuthService } from "@services/auth.service";
import { ToastService } from "angular-toastify";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Router } from "@angular/router";

@Component({
	moduleId: module.id,
	selector: "userSettings",
	styleUrls: ["userSettings.css"],
	templateUrl: "userSettings.html",
})
export class UserSettingsAdminComponent {
	changePasswordButton = {
		text: "Change Password",
		type: "default",
		useSubmitBehavior: true
	}
	cp: ChangePassword = new ChangePassword();
	dob = "";
	fullAddress = "";
	headerPrimaryButtons: AdminHeaderButton[] = [{ icon: "fal fa-calendar", method: "viewHolidays", text: "Holidays" }];
	member: UserProfile = new UserProfile();
	memberDto: UpdateProfile = new UpdateProfile();
	message = "";
	passwordStrength = 0;
	strengthColor = "#ccc";
	strengthLabel = "";
	title = "User Settings";
	titles: string[] = [];
	toastVisible = false;
	type = "info";
	updateProfileButton = {
		text: "Update Profile",
		type: "default",
		useSubmitBehavior: true
	}

	constructor(private router: Router, private toastService: ToastService, private authService: AuthService) {
		this.getTitles();
		this.getUser();
	}

	changePassword() {
		alert(this.cp.password);
	}

	checkPasswordStrength(): void {
		const password = this.cp.password || "";
		let strength = 0;

		if (password.length >= 8) strength +=1;
		if (/[A-Z]/.test(password)) strength +=1;
		if (/[a-z]/.test(password)) strength +=1;
		if (/[0-9]/.test(password)) strength +=1;
		if (/[\W_]/.test(password)) strength +=1;

		this.passwordStrength = (strength / 5) * 100;

		if (strength <= 2) {
			this.strengthLabel = "Weak";
			this.strengthColor = "red";
		} else if (strength === 3 || strength === 4) {
			this.strengthLabel = "Moderate";
			this.strengthColor = "orange";
		} else {
			this.strengthLabel = "Strong";
			this.strengthColor = "green";
		}
	}

	getTitles() {
		this.authService.getTitles()
			.subscribe(
				(res: any) => this.titles = res.response,
				(err) => console.log(err)
			);
	}

	getUser() {
		this.authService.getCurrentUserProfile()
			.subscribe(
				(res: any) => {
					this.member = res.response;
					this.fullAddress = this.member.address1 + ", \n" + (this.member.address2 != null ? this.member?.address2 + ", \n" : "") + this.member.town + ", \n" + this.member.postcode;
					console.log(this.member.dateOfBirth);
					this.dob = new Date(this.member.dateOfBirth).toDateString();
					console.log(this.dob);
				},
				(err) => console.log(err)
			);
		//this.memberOriginal = JSON.parse(JSON.stringify(this.member));
	}

	handleProfileSubmit(e: any) {
		this.memberDto.address1 = this.member.address1;
		this.memberDto.address2 = this.member.address2;
		this.memberDto.postcode = this.member.postcode;
		this.memberDto.town = this.member.town;
		this.memberDto.email = this.member.email;
		this.memberDto.firstName = this.member.firstName;
		this.memberDto.lastName = this.member.lastName;
		this.memberDto.jobTitle = this.member.jobTitle;
		this.memberDto.telephoneNumber = this.member.telephoneNumber;
		this.memberDto.title = this.member.title;
		this.memberDto.userId = this.member.userId;

		this.authService.updateAccount(this.memberDto)
			.subscribe(
				() => this.toastService.success("Profile Updated"),
				() => this.toastService.error("Something went wrong")
			);
		e.preventDefault();
	}

	handleSubmit(e: any) {
		this.authService.updatePassword(this.cp)
			.subscribe(
				() => {
					this.toastService.success("Password Updated");
					this.cp = new ChangePassword();
				},
				() => this.toastService.error("Something went wrong")
			);
		e.preventDefault();
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	viewHolidays() {
		this.router.navigate(["/admin/userHolidays"]);
	}
}